import { Component, Inject, Injector, OnInit } from "@angular/core";
import { TuiDialogContext, TuiDialogService } from "@taiga-ui/core";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
@Component({
  selector: "app-awardletterpopup",
  templateUrl: "./awardletterpopup.component.html",
  styleUrls: ["./awardletterpopup.component.scss"],
})
export class AwardletterpopupComponent implements OnInit {
  awdletterSrc: any;
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>,
    public globalvar: GlobalVarService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.awdletterSrc = context.data;
    // this.awdletterSrc = this.globalvar.getHost() + "fileStorage/download/" + id;
  }

  ngOnInit(): void {}

  close() {
    this.context.completeWith("");
  }

  getImgSrc(src: string) {
    return this.globalvar.getHost() + "fileStorage/download/" + src;
  }
}
